/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Copy/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import HelpTooltip from './HelpTooltip/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconCopy from 'DesignSystem/Svgs/TysiaIconCopy/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Copy({
  children,
  value,
  text,
  useRaw,
  viewPath = "/DesignSystem/Copy",
  hovered,
  onMouseEnter,
  onMouseLeave,
  marginLeft,
  marginTop,
  fill
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let marginLeftOrdtSpaceXxs = marginLeft ?? dtSpaceXxs
let onClick = fromHelpers.useOnClick({
  children,
  value,
  text,
  useRaw,
  viewPath,
  hovered,
  onMouseEnter,
  onMouseLeave,
  marginLeft,
  marginTop,
  fill
  
})
  return (<React.Fragment
>
<div
  data-testid="Copy.Horizontal"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-9h2R': typeof marginLeftOrdtSpaceXxs === 'number' ? `${marginLeftOrdtSpaceXxs}px` : marginLeftOrdtSpaceXxs,'--mt-2-9h2R': typeof marginTop === 'number' ? `${marginTop}px` : marginTop}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 type="ghost"
 size="small"
 title={text}
 marginBottom={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconCopy
{...childProps}
  viewPath={`${viewPath}/TysiaIconCopy`}
 fill={fill}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<HelpTooltip
  viewPath={`${viewPath}/HelpTooltip`}
 hovered={hovered}
 text={text}
/>
</div>
{children}
</React.Fragment>)
}